/* eslint-disable */
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import DraggableList from "../../common/components/draggableList/DraggableList";
import {AppState} from "../../root/RootReducer";
import {
    UpdateRecVideos,
    UpdateRecPrograms,
    UpdateRecProfessionals,
    GetRecVideoList,
    GetRecommendProfessionalList,
    GetRecommendProgramList
} from "../../common/homePage/HomePageActions";
import {CircularProgress} from "@material-ui/core";
import PuiTypography from "../../components/elements/PuiTypography";
import PuiFloatButton from "../../components/elements/PuiFloatButton";
import useResponsive from "../../common/useResponsive";
import styles from "./EditReconmmend.module.css";

const useStyles = makeStyles(() =>
    createStyles({
        rootPc: {
            // flexGrow: 1,
            display: "flex",
            justifyContent: "space-around",
            position: "relative",
            height: "83vh"
       },
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            position: "relative",
            height: "83vh",
            overflow: "auto"
        },
        updateButton: {
            position: "fixed",
            bottom: "10px",
            right: "6vw"
       },
        noContent: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "75vh"
       }
   })
);
interface EditRecommendProps {
    setIsSaved: (isSaved: boolean) => void;
    isSaved: boolean;
}

export default function EditRecommend({setIsSaved, isSaved}: EditRecommendProps) {

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
   }));

    const classes = useStyles();
    const dispatch = useDispatch();
    const { isDesktop, isMobile } = useResponsive();

    //APIコール
    useEffect(() => {
        console.log("useEffect");
        dispatch(GetRecVideoList());
        // dispatch(GetRecommendProgramList());
        dispatch(GetRecommendProfessionalList());
   }, [dispatch]);

    useEffect(() => {
        if (userInfo) dispatch(GetRecommendProgramList(userInfo.id));
   }, [dispatch, userInfo]);


    const {recommendVideoList, isLoading} = useSelector(({recommendList}: AppState) => recommendList);
    const {recommendProgramList} = useSelector(({recommendList}: AppState) => recommendList);
    const {recommendProfessionalList} = useSelector(({recommendList}: AppState) => recommendList);

    // 更新予定リストの枠
    const [recVideos, SetRecVideos] = useState<string[]>([]);
    const [recPrograms, SetRecPrograms] = useState<string[]>([]);
    const [recProfessionals, SetRecProfessionals] = useState<string[]>([]);

    // 更新したかどうかのフラグ
    const [isEditVideo, ChangeVideoFlag] = useState(false);
    const [isEditProgram, ChangeProgramFlag] = useState(false);
    const [isEditProfessional, ChangeProfessionalFlag] = useState(false);

    // 各おすすめリストの更新
    const handleUpdate = ( targetId: string, list: any ) => {
        // 更新されたリストをセット
        console.log("更新対象：",targetId, list);
        const updateList = [];
        for (let i = 0; i < list.length; i++) {
            const element = String(list[i].id);
            updateList.push(element);
       }

        setIsSaved(false);
        // 更新対象をセット
        switch (targetId) {
            case "video":
                SetRecVideos(updateList);
                ChangeVideoFlag(true);
                break;
            case "program":
                SetRecPrograms(updateList);
                ChangeProgramFlag(true);
                break;
            case "professional":
                SetRecProfessionals(updateList);
                ChangeProfessionalFlag(true);
                break;
       }
   };

    // 更新ボタンを効果
    const handleSubmit = () => {
        console.log("handleSubmit start");
        if (isEditVideo){
            console.log("更新予定のビデオ",recVideos);
            dispatch(UpdateRecVideos(recVideos));
            ChangeVideoFlag(false);
       }
        if (isEditProgram){
            console.log("更新予定のプログラム",recPrograms);
            if (userInfo) dispatch(UpdateRecPrograms(recPrograms, userInfo.id));
            ChangeProgramFlag(false);
       }
        if (isEditProfessional){
            console.log("更新予定のプロフェッショナル",recProfessionals);
            dispatch(UpdateRecProfessionals(recProfessionals));
            ChangeProfessionalFlag(false);
       }
        setIsSaved(true);
   };

    // 表示待機
    if (isLoading) {
        return (
            <div className={classes.noContent}>
                <CircularProgress size={60} style={{color: "var(--red)"}}/>
            </div>
        );
   }

    return (
        <>
            <div className={isDesktop ? classes.rootPc : classes.root}>
                {/* <div className={styles.recommendList}>
                    <div className={styles.recommendListTitle}>
                        <PuiTypography size={isDesktop ? 24 : 20} bold={true}>おすすめVideo</PuiTypography>
                    </div>
                    <div className={styles.recommendListItems}>
                        <DraggableList
                            type="video"
                            targetList={recommendVideoList}
                            onUpdate={handleUpdate}
                            listHeight={isDesktop ? 550 : isMobile ? 50 * recommendVideoList.length : 60 * recommendVideoList.length}/>
                    </div>
                </div> */}
                <div className={styles.recommendList}>
                    <div className={styles.recommendListTitle}>
                        <PuiTypography size={isDesktop ? 24 : 20} bold={true}>おすすめChannel</PuiTypography>
                    </div>
                    <div className={styles.recommendListItems}>
                        <DraggableList
                            type="program"
                            targetList={recommendProgramList}
                            onUpdate={handleUpdate}
                            listHeight={isDesktop ? 550 : isMobile ? 50 * recommendProgramList.length : 60 * recommendProgramList.length}/>
                    </div>
                </div>
                <div className={styles.recommendList}>
                    <div className={styles.recommendListTitle}>
                        <PuiTypography size={isDesktop ? 24 : 20} bold={true}>おすすめPresenter</PuiTypography>
                    </div >
                    <div className={styles.recommendListItems}>
                        <DraggableList
                            type="professional"
                            targetList={recommendProfessionalList}
                            onUpdate={handleUpdate}
                            listHeight={isDesktop ? 550 : isMobile ? 50 * recommendProfessionalList.length : 60 * recommendProfessionalList.length}/>
                    </div>
                </div>
                <div className={classes.updateButton}>
                    <PuiFloatButton children={["　更新　"]} size="medium" isActive={!isSaved} onClick={handleSubmit}/>
                </div>
            </div>
        </>
    );

}
